import { IconWrapper } from '../runtime';
export default IconWrapper('todo-list-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("g", [h("g", {
    "attrs": {
      "filter": 'url(#' + props.id + 'dfc53e8c' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '51450d03' + ')'
    }
  })]), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M15.0843 5.03312L16.6753 6.62411L12.0053 11.2941L9.88394 9.1728L14.0236 5.03312C14.3165 4.74023 14.7914 4.74023 15.0843 5.03312ZM7.76262 11.2941L5.64132 13.4154L11.4749 19.2491C11.7678 19.542 12.2427 19.542 12.5356 19.2491L20.3876 11.3971C20.6805 11.1042 20.6805 10.6293 20.3876 10.3364L18.7966 8.74543L14.1266 13.4154L12.0053 15.5368L7.76262 11.2941Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "opacity": "0.5",
      "d": "M3.63043 11.3942C3.33754 11.1013 3.33753 10.6264 3.63043 10.3335L8.93373 5.03025C9.22662 4.73735 9.7015 4.73735 9.99439 5.03025L12.0117 7.04757L5.64775 13.4115L3.63043 11.3942Z",
      "fill": "white"
    }
  })]), h("defs", [h("filter", {
    "attrs": {
      "id": props.id + 'dfc53e8c',
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), h("feOffset", {
    "attrs": {
      "dy": "-0.75"
    }
  }), h("feComposite", {
    "attrs": {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
    }
  }), h("feBlend", {
    "attrs": {
      "mode": "normal",
      "in2": "shape",
      "result": "effect1_innerShadow_913_632"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '51450d03',
      "x1": "2.23987e-07",
      "y1": "1.03431",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0.029618",
      "stop-color": "#26CD9B"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#01A88A"
    }
  })])])]);
});